module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Medium.f3b73884.woff";